import { useMemo, useState } from 'react';
import { useAuth } from './AuthContext';
import { watchedKeys } from './discoveryModel';

export function useWatched() {
  const { experience = {}, preferences = {} } = useAuth();
  const watched = useMemo(() => watchedKeys(experience.journal), [experience.journal]);
  return { watched, hideWatched:!!preferences.hideWatched };
}
export function HideWatchedControl() {
  const {user,preferences = {},savePreferences,openAuth} = useAuth();
  const [busy,setBusy] = useState(false), [error,setError] = useState('');
  const toggle = async () => {
    if (!user) { openAuth(); return; }
    setBusy(true); setError('');
    try { await savePreferences({hideWatched:!preferences.hideWatched}); }
    catch { setError('Could not update this preference. Try again.'); }
    finally { setBusy(false); }
  };
  return <div className="discovery-toggle"><button type="button" role="switch" aria-checked={!!preferences.hideWatched} disabled={busy} onClick={toggle}><span aria-hidden="true" className="toggle-track" />Hide watched titles</button><small>Uses watched dates in your movie journal.</small>{error && <p role="alert">{error}</p>}</div>;
}
